/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, movement: NonNullable<unknown> }} Prescription_Notice_Isolation_WithheldInputs */

const en_us2_prescription_notice_isolation_withheld = /** @type {(inputs: Prescription_Notice_Isolation_WithheldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: single-joint work (${i?.movement}) starts in week 5, as your protocol builds up.`)
};

const pt_br2_prescription_notice_isolation_withheld = /** @type {(inputs: Prescription_Notice_Isolation_WithheldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: exercícios isolados (${i?.movement}) entram a partir da semana 5, conforme o protocolo avança.`)
};

const es_419_prescription_notice_isolation_withheld = /** @type {(inputs: Prescription_Notice_Isolation_WithheldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: los ejercicios de aislamiento (${i?.movement}) entran a partir de la semana 5, a medida que avanza tu protocolo.`)
};

const pt_pt2_prescription_notice_isolation_withheld = /** @type {(inputs: Prescription_Notice_Isolation_WithheldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: os exercícios isolados (${i?.movement}) entram a partir da semana 5, à medida que o protocolo avança.`)
};

const fr_fr2_prescription_notice_isolation_withheld = /** @type {(inputs: Prescription_Notice_Isolation_WithheldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} : le travail monoarticulaire (${i?.movement}) arrive en semaine 5, au fil de ton protocole.`)
};

const de_de2_prescription_notice_isolation_withheld = /** @type {(inputs: Prescription_Notice_Isolation_WithheldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: Isolationsübungen (${i?.movement}) kommen ab Woche 5, wenn dein Protokoll aufbaut.`)
};

const it_it2_prescription_notice_isolation_withheld = /** @type {(inputs: Prescription_Notice_Isolation_WithheldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: il lavoro monoarticolare (${i?.movement}) entra dalla settimana 5, man mano che il protocollo avanza.`)
};

/**
* | output |
* | --- |
* | "{day}: single-joint work ({movement}) starts in week 5, as your protocol builds up." |
*
* @param {Prescription_Notice_Isolation_WithheldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_notice_isolation_withheld = /** @type {((inputs: Prescription_Notice_Isolation_WithheldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Notice_Isolation_WithheldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_notice_isolation_withheld(inputs)
	if (locale === "es-419") return es_419_prescription_notice_isolation_withheld(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_notice_isolation_withheld(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_notice_isolation_withheld(inputs)
	if (locale === "de-DE") return de_de2_prescription_notice_isolation_withheld(inputs)
	if (locale === "it-IT") return it_it2_prescription_notice_isolation_withheld(inputs)
	return en_us2_prescription_notice_isolation_withheld(inputs)
});
export { prescription_notice_isolation_withheld as "prescription.notice.isolation_withheld" }